import { ClickToCopy } from './sharelinks/ClickToCopy.tsx';
import { EmailLink } from './sharelinks/EmailLink.tsx';
import { FacebookLink } from './sharelinks/FacebookLink.tsx';
import { NextdoorGenericLink } from './NextdoorGenericLink';
import { MobileShareTray } from './sharelinks/MobileShareTray.tsx';
import { Svg } from './Svg';
import PropTypes from 'prop-types';
import React from 'react';

export let GenericShareBar = function ({
    urlToShare,
    trackedId,
    trackedPageType,
    wrapperStyleClassName,
    emailSharePageType,
    emailShareId,
    supportForName,
}) {
    function openUrl(event, url) {
        event.preventDefault();
        event.stopPropagation();
        window.open(url, '_blank');
    }

    function openNextdoorUrl(event, url) {
        openUrl(event, url);
    }

    function getEmailShareUrl() {
        // getTafURL has to be updated with new categories of share types based on pageName,
        // and a new sendFriend controller has to be built for that class.
        return getTafURL(emailSharePageType, emailShareId);
    }

    return (
        <div className={'share-wrapper donor-share-tools ' + wrapperStyleClassName}>
            <div className="options">
                <div className='copy-link-mobile'>
                    <ClickToCopy
                        useSpan={false}
                        buttonClassName='icon icon-ss-link'
                        textToCopy={baseURL + urlToShare}
                        getTrackingLink={getTrackingLink /* getTrackingLink is globally-defined */}
                        pageName={pageName /* pageName is globally-defined; it will be 'teacher' on this page */}
                    >
                        <><Svg icon="ss-link" iconFamily="social-circle"/> Copy link</>
                    </ClickToCopy>
                </div>
                <FacebookLink
                    useSpan={true}
                    className='icon icon-ss-facebook'
                    urlToShare={baseURL + urlToShare}
                    skipClipboardAndInterstitial={true}
                    getTrackingLink={getTrackingLink /* getTrackingLink is globally-defined */}
                    facebookAppId={facebookAppId /* facebookAppId is globally-defined */}
                    pageName={pageName /* pageName is globally-defined */}
                >
                    <Svg icon="ss-facebook" iconFamily="social-circle"/> Facebook
                </FacebookLink>
                <EmailLink
                    useSpan={true}
                    className='icon icon-ss-mail'
                    secure={false}
                    tafURL={getEmailShareUrl()}
                    getTafEmail={getTafEmail}
                    pageName={pageName /* pageName is globally-defined */}
                    onEmailClick={() => {}}
                >
                    <span>Email</span>
                </EmailLink>
                <NextdoorGenericLink
                    className='icon icon-ss-nextdoor'
                    urlToShare={baseURL + urlToShare}
                    onNextdoorClick={openNextdoorUrl}
                    supportForName={supportForName}
                    pageName={pageName /* pageName is globally-defined; it will be 'teacher' on this page */}
                />
            </div>
            <div className='desktop'>
                <ClickToCopy
                    useSpan={true}
                    buttonClassName='icon icon-ss-link'
                    textToCopy={baseURL + urlToShare}
                    getTrackingLink={getTrackingLink /* getTrackingLink is globally-defined */}
                    pageName={pageName /* pageName is globally-defined; it will be 'teacher' on this page */}
                >
                    Copy link
                </ClickToCopy>
            </div>
            <div className='mobile-share mobile'>
                <MobileShareTray
                    useSpan={true}
                    className='share-tray icon icon-ss-sharetray'
                    urlToShare={baseURL + urlToShare}
                    onShareTrayClick={() => {}}
                    getTrackingLink={getTrackingLink /* getTrackingLink is globally-defined */}
                    projectSummary={supportForName}
                    pageName={pageName}
                />
            </div>
        </div>
    );
};

GenericShareBar.propTypes = {
    urlToShare: PropTypes.string.isRequired,
    trackedId: PropTypes.string.isRequired,
    trackedPageType: PropTypes.string.isRequired,
    wrapperStyleClassName: PropTypes.string.isRequired,
    emailSharePageType: PropTypes.string,
    emailShareId: PropTypes.string,
    supportForName: PropTypes.string,
};

GenericShareBar = React.memo(GenericShareBar);
